import { Dayjs } from "dayjs";
import { parseStringBySeparator } from "utils/helpers";

interface FormData {
    title: string;
    viewFromDate: Dayjs | null;
    viewToDate: Dayjs | null;
    dimensionColumnTitles: string;
}

interface FormErrors {
    title: string;
    viewFromDate: string;
    viewToDate: string;
}

const ERROR_MESSAGES = {
    REQUIRED: 'Input is required',
    INVALID_DATE_RANGE: '"View To" date cannot be earlier than "View From" date',
};

export const validateFormData = (formData: FormData): FormErrors => {
    const errors: FormErrors = {
        title: formData.title ? '' : ERROR_MESSAGES.REQUIRED,
        viewFromDate: formData.viewFromDate ? '' : ERROR_MESSAGES.REQUIRED,
        viewToDate: formData.viewToDate ? '' : ERROR_MESSAGES.REQUIRED,
    };

    if (formData.viewFromDate && formData.viewToDate && formData.viewToDate < formData.viewFromDate) {
        errors.viewToDate = ERROR_MESSAGES.INVALID_DATE_RANGE;
    }

    return errors;
};

export const getRequestBody = (
    formData: FormData
): { title: string; startDate: string; endDate: string; dimensions: string[] } => ({
    title: formData.title,
    startDate: formData.viewFromDate ? formData.viewFromDate.startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
    endDate: formData.viewToDate ? formData.viewToDate.startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
    dimensions: parseStringBySeparator(formData.dimensionColumnTitles, ';'),
});